import { Controller } from 'stimulus';
import Cookies from 'js-cookie';
import { getWindowWidth } from 'lib/helpers';

export default class FooterAdController extends Controller {
    static targets = [
      'stickyFooterAd',
    ];

    connect() {
      this.handleMobileAd();
    }

    handleMobileAd = () => {
      if (getWindowWidth() <= 900) {
        this.element.remove();
      }
    }

    close = () => {
      this.element.remove();
      document.querySelector('.ez-site-footer').classList.remove('ez-site-footer--has-sticky-ad');
      Cookies.set('sticky_footer_ad_dismissed', true);
    }
}
